if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.slider = this.querySelector('.swiper');
        this.slides = this.querySelectorAll('.swiper-slide');
        this.prevButton = this.querySelector('.modalPrev');
        this.nextButton = this.querySelector('.modalNext');

        if (this.slides.length <= 1) {
          this.prevButton.hidden = true;
          this.nextButton.hidden = true;
        }

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.swiper?.slidePrev();
          if (event.code === 'ArrowRight') this.swiper?.slideNext();
        });

        this.slider.querySelectorAll('img').forEach((img) => {
          img.addEventListener('dragstart', (event) => event.preventDefault());
        });

        // 画像のスライドだけ Swiper のズーム機構に渡す（動画と3Dモデルは自前の操作がある）。
        // Swiper は「囲みを動かして中の画像を拡大する」ので、画像を包む箱をここで足す
        this.zoomTargets = [];
        this.slides.forEach((slide) => {
          const image = slide.querySelector(':scope > img');
          if (!image) return;
          const container = document.createElement('div');
          container.className = 'swiper-zoom-container';
          slide.insertBefore(container, image);
          container.appendChild(image);
          this.zoomTargets.push(container);
        });

        this.initSwipeToDismiss();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        if (!this.swiper && typeof Swiper !== 'undefined') {
          const options = {
            slidesPerView: 1,
            speed: 400,
            simulateTouch: true,
            grabCursor: true,
            threshold: 5,
            resistanceRatio: 0.85,
            navigation: {
              prevEl: this.prevButton,
              nextEl: this.nextButton,
            },
          };
          if (this.zoomTargets.length) options.zoom = { enabled: true, maxRatio: 3 };
          this.swiper = new Swiper(this.slider, options);
        }

        if (!this.swiper) return;

        // 閉じている間は表示から外れて幅が 0 になるので、開くたびに測り直す
        this.swiper.update();

        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`)?.closest('.swiper-slide');
        if (!activeSlide) return;

        const index = Array.from(this.slides).indexOf(activeSlide);
        this.swiper.slideTo(index, 0);
      }
    }
  );
}
